import { memo } from "react";

import { type TTailwindString, tw } from "classnames";

const placeholderStyle = tw("bg-placeholder", "rounded", "animate-pulse");

const styles = {
  base: tw(
    "w-full",
    "md:flex",
    "py-6",
    "md:py-10",
    "border-0",
    "border-b",
    "border-solid",
    "border-char-300"
  ),
  metadata: tw(
    "flex-shrink-0",
    "w-44",
    "mr-10",
    "mb-6",
    "md:mb-0",
    "text-primary"
  ),
  authorInfo: tw(
    "mb-2",
    "md:mb-3",
    "flex",
    "items-center",
    "gap-x-2",
    "md:block"
  ),
  reviewData: tw("flex-1", "md:pr-3.5"),
  reviewStarsMobile: tw("w-20", "h-4", "mb-2", "md:hidden", placeholderStyle),
  reviewStarsDesktop: tw(
    "w-20",
    "h-4",
    "mb-2.5",
    "hidden",
    "md:block",
    placeholderStyle
  ),
  displayName: tw(
    "w-[102px]" as TTailwindString,
    "h-6",
    "md:mb-2",
    placeholderStyle
  ),
  verifiedBuyer: tw("w-20", "h-3.5", "md:mb-2", placeholderStyle),
  date: tw("w-20", "h-[11px]" as TTailwindString, placeholderStyle),
  title: tw("w-40", "h-4", "mb-3", placeholderStyle),
  textLineFull: tw("w-full", "h-4", "mb-1.5", placeholderStyle),
  textLinePartial: tw("w-4/5", "h-4", placeholderStyle),
  vote: tw("w-40", "h-4", "mt-5", "mb-1", placeholderStyle),
  images: tw("flex", "flex-row"),
  image: tw("w-22", "h-22", "mt-5", "mr-3", placeholderStyle),
};

const ReviewItemPlaceholderBase = ({
  hasImage = false,
}: {
  hasImage?: boolean;
}) => {
  return (
    <div className={styles.base}>
      <div className={styles.metadata}>
        <div className={styles.reviewStarsMobile} />
        <div className={styles.authorInfo}>
          <div className={styles.displayName} />
          <div className={styles.verifiedBuyer} />
        </div>
        <div className={styles.date} />
      </div>
      <div className={styles.reviewData}>
        <div className={styles.reviewStarsDesktop} />
        <div className={styles.title} />
        <div className={styles.textLineFull} />
        <div className={styles.textLinePartial} />
        {hasImage && (
          <div className={styles.images}>
            <div className={styles.image} />
            <div className={styles.image} />
          </div>
        )}
        <div className={styles.vote} />
      </div>
    </div>
  );
};

export const ReviewItemPlaceholder = memo(ReviewItemPlaceholderBase);
